import { render, staticRenderFns } from "./card-ecommend.vue?vue&type=template&id=04644eda&scoped=true&"
import script from "./card-ecommend.vue?vue&type=script&lang=js&"
export * from "./card-ecommend.vue?vue&type=script&lang=js&"
import style0 from "./card-ecommend.vue?vue&type=style&index=0&id=04644eda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04644eda",
  null
  
)

export default component.exports